import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
// import { MenuService } from '@core';
import { IMenu } from '../../models/core/menu';
import { environment } from 'environments/environment';
import { SharedService } from 'app/services/core/shared.service';
import { MenuService } from 'app/services/core/menu.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SidebarComponent {
  // NOTE: Ripple effect make page flashing on mobile
  @Input() ripple = false;
  @Input() isMobile = false;

  menu$ = this.menu.getAll();
  menuResponse: IMenu[] = [];
  buildRoute = this.menu.buildRoute;
  @Output() toggleCollapsed = new EventEmitter<void>();

  constructor(private menu: MenuService, private service :SharedService) { }

  ngOnInit() {
    //This sets up the namespace required for translating the sidebar options
    // if (this.service.userAuthenticated()){
    //   // this.service.setRoles();
    // }

    this.menu$.subscribe(
      response => {
        if (environment.translateText) {
          this.menu.addNamespace(response, 'menu');
        }
      }
    )
  }

}
